import { Dialog, DialogActions, DialogContent, DialogTitle, FormControlLabel, Modal, Radio, RadioGroup, Step, StepLabel, Stepper } from "@mui/material";
import {
  CategoryScale,
  Chart as ChartJS,
  Filler,
  Legend,
  LinearScale,
  LineElement,
  PointElement,
  Title,
  Tooltip
} from 'chart.js';
import React, { useEffect, useState } from 'react';
import Select from "react-select";
import './dashboard.scss';
import { CheckCircle } from '@mui/icons-material';
import CloseIcon from "@mui/icons-material/Close";
import { IconButton } from "@mui/material";
import type { ApexOptions } from "apexcharts";
import ReactApexChart from 'react-apexcharts';
import { useNavigate } from 'react-router-dom';
import { toast } from "react-toastify";
import { useCreatePatientMutation, useGetallergiesChronicDeaseseQuery, useGetPatientListQuery, useGetdashboardDataQuery, useGetmedicationSupplementQuery, useMarkTakenMutation } from '../../utils/apiSlice';
import {
  getEffectiveUserData,
  readActiveProfile,
  readPrimaryUserData,
  patchActiveRelatedPatientId,
} from "../../utils/activeProfileStorage";
import { Modal as Modal1 } from "antd";
import { useEffectiveUserData } from "../../hooks/useEffectiveUserData";
import { CloseOutlined } from "@ant-design/icons";
import {
  formatHeightFtInInput,
  sanitizeHeightFtInTyping,
  validateHeightCm,
  validateHeightFtIn,
  validateWeightKg,
  validateWeightLbs,
} from "../../utils/heightWeightFormat";
import { PlusCircleOutlined, FileTextOutlined, UploadOutlined } from "@ant-design/icons";
import { triggerCoins } from "../canvasConfict";
import medicine from '../../assets/images/flat-icon/medicine-1.png';
import check from '../../assets/images/flat-icon/check-mark.png';
ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend, Filler);


const Dashboard = () => {
  const userData = useEffectiveUserData();
  const primaryUser = readPrimaryUserData();
  const isPatientIdNull = !userData?.patientId;
  const patientID = userData?.patientId
  const [questionnaireData, setQuestionnaireData] = useState<any>({
    firstName: userData?.firstName || "",
    middleName: userData?.middleName || "",
    lastName: userData?.lastName || "",
    bloodGroup: "",
    dateOfBirth: "",
    gender: null,
    sexAssignedAtBirth: null,
    height: "",
    weight: "",
    currentLocation: "",
    emergencyContactName: "",
    emergencyRelationship: "",
    emergencyPhoneNumber: "",
    emergencyContactConsent: null,
    diagnosedConditionIds: [],
    allergyIds: [],
    currentlyTakingMedications: null,
    patientMedicationIds: [],
    supplementIds: [],
    familyHistoryDiseaseIds: [],
    goals: "",
    finalInput: "",
  });


  const [selectedConditions, setSelectedConditions] = useState<any[]>([]);
  const [selectedAllergies, setSelectedAllergies] = useState<any[]>([]);
  const [selectedMedications, setSelectedMedications] = useState<any[]>([]);
  const [selectedSupplements, setSelectedSupplements] = useState<any[]>([]);
  const [selectedFamilyHistory, setSelectedFamilyHistory] = useState<any[]>([]);

  const navigate = useNavigate();
  const [createPatient, { isLoading: isPostLoading }] = useCreatePatientMutation();
  const [conditionSearch, setConditionSearch] = useState("");
  const [allergySearch, setAllergySearch] = useState("");
  const [familySearch, setFamilySearch] = useState("");

  const [medicationSearch, setMedicationSearch] = useState("");
  const [supplementSearch, setSupplementSearch] = useState("");

  // const [showModal1, setShowModal1] = useState(isPatientIdNull);
  const [showModal1, setShowModal1] = useState(false);
  const primaryUserId = primaryUser.userId ?? primaryUser.patientId;

  const patientContextKey = `${userData?.userId ?? ""}-${userData?.patientId ?? ""}`;

  useEffect(() => {
    const u = getEffectiveUserData();
    const needsQuestionnaire = !u?.patientId;

    if (needsQuestionnaire) {
      setQuestionnaireData({
        firstName: u.firstName || "",
        middleName: u.middleName || "",
        lastName: u.lastName || "",
        bloodGroup: "",
        dateOfBirth: "",
        gender: null,
        sexAssignedAtBirth: null,
        height: "",
        weight: "",
        currentLocation: "",
        emergencyContactName: "",
        emergencyRelationship: "",
        emergencyPhoneNumber: "",
        emergencyContactConsent: null,
        diagnosedConditionIds: [],
        allergyIds: [],
        currentlyTakingMedications: null,
        patientMedicationIds: [],
        supplementIds: [],
        familyHistoryDiseaseIds: [],
        goals: "",
        finalInput: "",
      });
      setSelectedConditions([]);
      setSelectedAllergies([]);
      setSelectedMedications([]);
      setSelectedSupplements([]);
      setSelectedFamilyHistory([]);
      setActiveStep(0);
      setErrors({});
    } else {
      setQuestionnaireData((prev: any) => ({
        ...prev,
        firstName: u.firstName || "",
        middleName: u.middleName || "",
        lastName: u.lastName || "",
      }));
    }
    // setShowModal1(needsQuestionnaire);
  }, [patientContextKey]);

  const { data: relatedUsersResponse } = useGetPatientListQuery(primaryUserId, {
    skip: !showModal1 || primaryUserId === undefined || primaryUserId === null,
  });

  const { data: conditionResults } = useGetallergiesChronicDeaseseQuery(conditionSearch, {
    skip: !showModal1 || conditionSearch.length === 1,
  });

  const { data: allergyResults } = useGetallergiesChronicDeaseseQuery(allergySearch, {
    skip: !showModal1 || allergySearch.length === 1,
  });

  const { data: familyResults } = useGetallergiesChronicDeaseseQuery(familySearch, {
    skip: !showModal1 || familySearch.length === 1,
  });

  const { data: medicationResults } = useGetmedicationSupplementQuery(medicationSearch, {
    skip: !showModal1 || medicationSearch.length === 1,
  });

  const { data: supplementResults } = useGetmedicationSupplementQuery(supplementSearch, {
    skip: !showModal1 || supplementSearch.length === 1,
  });

  const relationshipTypeOptions = React.useMemo(() => {
    const items = relatedUsersResponse?.data || relatedUsersResponse?.items || [];
    const rawValues = Array.isArray(items)
      ? items
        .map((it: any) => it?.relationshipType ?? it?.relationship ?? it?.relationship_type)
        .filter(Boolean)
      : [];

    const unique = Array.from(
      new Set(
        rawValues
          .map((v: any) => String(v).trim().toUpperCase())
          .filter(Boolean)
      )
    );
    return unique;
  }, [relatedUsersResponse]);

  const relationshipTypeSelectOptions = React.useMemo(() => {
    const fallback = ["SPOUSE", "PARENT", "CHILD", "SIBLING", "FRIEND", "OTHER"];
    const rels = relationshipTypeOptions.length ? relationshipTypeOptions : fallback;
    return rels.map((rel) => ({ value: rel, label: rel.charAt(0).toUpperCase() + rel.slice(1).toLowerCase() }));
  }, [relationshipTypeOptions]);

  const selectedRelationshipOption = React.useMemo(() => {
    const current = String(questionnaireData?.emergencyRelationship ?? "")
      .trim()
      .toUpperCase();
    return relationshipTypeSelectOptions.find((o) => o.value === current) || null;
  }, [questionnaireData?.emergencyRelationship, relationshipTypeSelectOptions]);

  // Prevent spacebar from selecting options inside react-select dropdowns
  // while the questionnaire dialog is open.
  React.useEffect(() => {
    if (!showModal1) return;

    const onKeyDownCapture = (ev: KeyboardEvent) => {
      const isSpace =
        ev.key === " " || ev.code === "Space" || (ev as any).key === "Spacebar";
      if (!isSpace) return;

      const menu = document.querySelector(".react-select__menu .react-select__option");
      if (!menu) return;

      // Block space completely when any react-select menu is open
      ev.preventDefault();
      ev.stopImmediatePropagation();
    };

    document.addEventListener("keydown", onKeyDownCapture, true);
    return () => document.removeEventListener("keydown", onKeyDownCapture, true);
  }, [showModal1]);
  const convertFtInToCm = (value: any) => {
    if (!value) return null;

    const match = value.match(/(\d+)[^\d]+(\d+)/); // e.g. 5'10
    if (!match) return null;

    const ft = parseInt(match[1] || 0);
    const inch = parseInt(match[2] || 0);

    return ft * 30.48 + inch * 2.54;
  };

  const { data } = useGetdashboardDataQuery(patientID, {
    skip: !patientID,
  });

  const vitals = data?.data?.vitals;

  const dashboardData = data?.data ?? {};


  const drugIntake = dashboardData?.drugIntake?.length > 0 ? dashboardData.drugIntake : [

    // { medicationId: 1, medicationName: "Metformin 500mg", intakeDate: "2026-03-19", scheduledTime: "08:00 AM", dosage: "1 Tablet" },
    // { medicationId: 2, medicationName: "Amlodipine 5mg", intakeDate: "2026-03-19", scheduledTime: "09:00 AM", dosage: "1 Tablet" },
    // { medicationId: 3, medicationName: "Vitamin D3 1000IU", intakeDate: "2026-03-19", scheduledTime: "01:00 PM", dosage: "1 Capsule" },
  ];
  const notifications = dashboardData?.notifications?.items?.length > 0 ? dashboardData.notifications.items : [
    // { id: 1, title: "Appointment Reminder", message: "Dr. Smith appointment tomorrow at 10:00 AM", time: "2 hours ago" },
    // { id: 2, title: "Lab Report Ready", message: "Your blood test report is ready to view", time: "5 hours ago" },
    // { id: 3, title: "Medication Reminder", message: "Time to take Metformin 500mg", time: "1 day ago" },
  ];

  const handleInputChange = (e: any) => {
    const { name, value } = e.target;

    if (name === "emergencyPhoneNumber") {
      let onlyNums = value.replace(/\D/g, "").slice(0, 10);

      setQuestionnaireData((prev: any) => ({ ...prev, [name]: onlyNums }));

      const phoneRegex = /^[6-9]\d{9}$/;

      // Show error only when user has typed something
      if (onlyNums.length > 0 && !phoneRegex.test(onlyNums)) {
        setErrors((prev: any) => ({
          ...prev,
          emergencyPhoneNumber: "Enter valid 10-digit number starting with 6-9",
        }));
      } else {
        setErrors((prev: any) => ({
          ...prev,
          emergencyPhoneNumber: undefined,
        }));
      }

      return;
    }

    setQuestionnaireData((prev: any) => ({ ...prev, [name]: value }));

    if (errors[name]) {
      setErrors((prev: any) => ({ ...prev, [name]: undefined }));
    }
  };

  const mergeOptions = (selected: any[] = [], apiOptions: any[] = []) => {
    const map = new Map<string, any>();

    const keyOf = (item: any) => {
      const id = item?.id ?? item?.value ?? item?.name ?? item?.parentName ?? item?.relationshipType ?? item?.relationship;
      return id === undefined || id === null || id === "" ? null : String(id).trim().toUpperCase();
    };

    [...selected, ...apiOptions].forEach((item) => {
      const key = keyOf(item);
      if (!key) return;
      const normalized = { ...item, id: item?.id ?? item?.name ?? item?.parentName ?? item?.value };
      map.set(key, normalized);
    });

    return Array.from(map.values());
  };

  const getAgeInMonths = (dob: any) => {
    if (!dob) return null;

    const birth = new Date(dob);
    const today = new Date();

    let months =
      (today.getFullYear() - birth.getFullYear()) * 12 +
      (today.getMonth() - birth.getMonth());

    return months;
  };
  const conditionApiOptions =
    conditionResults?.data?.map((item: any) => ({
      id: item.id,
      name: item.parentName,
      descriptions: item.shortDescription,
    })) || [];

  const conditionOptions = mergeOptions(selectedConditions, conditionApiOptions);


  const allergyApiOptions =
    allergyResults?.data?.map((item: any) => ({
      id: item.id,
      name: item.parentName,
      descriptions: item.shortDescription,
    })) || [];

  const allergyOptions = mergeOptions(selectedAllergies, allergyApiOptions);


  const familyApiOptions =
    familyResults?.data?.map((item: any) => ({
      id: item.id,
      name: item.parentName,
      descriptions: item.shortDescription,
    })) || [];

  const familyOptions = mergeOptions(selectedFamilyHistory, familyApiOptions);

  const medicationApiOptions =
    medicationResults?.data?.map((item: any) => ({
      id: item.id,
      name: item.name,
      descriptions: item.name,
    })) || [];

  const medicationOptions = mergeOptions(selectedMedications, medicationApiOptions);

  const supplementApiOptions =
    supplementResults?.data?.map((item: any) => ({
      id: item.id,
      name: item.name,
      descriptions: item.name,
    })) || [];

  const supplementOptions = mergeOptions(selectedSupplements, supplementApiOptions);

  const formatName = (name: string) => {
    if (!name) return "";
    return name.charAt(0).toUpperCase() + name.slice(1).toLowerCase();
  };

  const [showConfirm, setShowConfirm] = useState(false);
  const [selectedPerson, setSelectedPerson] = useState("");

  const [activeStep, setActiveStep] = useState(0);


  const [errors, setErrors] = useState<any>({});

  const formatDecimal = (value: number) =>
    Number.isInteger(value) ? String(value) : value.toFixed(1).replace(/\.0$/, "");

  const inferHeightUnit = (value: any) => String(value || "").includes("'") ? "ft/in" : "cm";
  const inferWeightUnit = (value: any) => String(value || "").toLowerCase().includes("lb") ? "lbs" : "kg";

  const cmToFeetInches = (value: any) => {
    const cm = Number(value);
    if (!value || Number.isNaN(cm)) return "";
    const totalInches = Math.round(cm / 2.54);
    const feet = Math.floor(totalInches / 12);
    const inches = totalInches % 12;
    return `${feet}'${inches}"`;
  };

  const feetInchesToCm = (value: any) => {
    const match = String(value).match(/(\d+)\s*'\s*(\d{1,2})"?/);
    if (!match) return "";
    const feet = Number(match[1]);
    const inches = Number(match[2]);
    return String(Math.round((feet * 12 + inches) * 2.54));
  };

  const kgToLbs = (value: any) => {
    const kg = Number(value);
    if (!value || Number.isNaN(kg)) return "";
    return formatDecimal(kg * 2.20462);
  };

  const lbsToKg = (value: any) => {
    const lbs = Number(value);
    if (!value || Number.isNaN(lbs)) return "";
    return formatDecimal(lbs / 2.20462);
  };

  const handleHeightUnitChange = (nextUnit: "cm" | "ft/in") => {
    if (nextUnit === units.height) return;
    setQuestionnaireData((prev: any) => ({
      ...prev,
      height: nextUnit === "ft/in" ? cmToFeetInches(prev.height) : feetInchesToCm(prev.height),
    }));
    setUnits((prev) => ({ ...prev, height: nextUnit }));
  };

  const handleWeightUnitChange = (nextUnit: "kg" | "lbs") => {
    if (nextUnit === units.weight) return;
    setQuestionnaireData((prev: any) => ({
      ...prev,
      weight: nextUnit === "lbs" ? kgToLbs(prev.weight) : lbsToKg(prev.weight),
    }));
    setUnits((prev) => ({ ...prev, weight: nextUnit }));
  };

  const handleQChange = (field: string, value: any) => {

    if (field === "firstName") {
      value = value.replace(/[^A-Za-z]/g, "");
    }
    if (field === "lastName") {
      value = value.replace(/[^A-Za-z]/g, "");
    }

    setQuestionnaireData((prev: any) => ({ ...prev, [field]: value }));

    if (errors[field]) {
      setErrors((prev: any) => ({ ...prev, [field]: undefined }));
    }
  };

  const validateStep = (step: number) => {
    const q = questionnaireData;
    let newErrors: any = {};

    if (step === 0) {
      if (!q.dateOfBirth) newErrors.dateOfBirth = "Date of Birth is required";
      if (!q.gender) newErrors.gender = "Gender identity is required";
      if (!q.sexAssignedAtBirth) newErrors.sexAssignedAtBirth = "Sex assigned at birth is required";
      const ageInMonths = getAgeInMonths(q.dateOfBirth);


      if (!q.height?.trim()) {
        newErrors.height = "Height is required";
      } else {
        let height =
          units.height === "cm"
            ? parseFloat(q.height)
            : convertFtInToCm(q.height);


        if (ageInMonths !== null && ageInMonths <= 1) {
          if (!height || height < 45 || height > 60) {
            newErrors.height = "For newborn, height must be between 45–60 cm";
          }
        } else {

          const hErr =
            units.height === "cm"
              ? validateHeightCm(String(q.height))
              : validateHeightFtIn(String(q.height));

          if (hErr) newErrors.height = hErr;
        }
      }


      if (!q.weight?.trim()) {
        newErrors.weight = "Weight is required";
      } else {
        let weight = parseFloat(q.weight);


        if (units.weight === "lbs") {
          weight = weight * 0.453592;
        }


        if (ageInMonths !== null && ageInMonths <= 1) {
          if (!weight || weight < 2 || weight > 5) {
            newErrors.weight = "For newborn, weight must be between 2–5 kg";
          }
        } else {

          const wErr =
            units.weight === "kg"
              ? validateWeightKg(String(q.weight))
              : validateWeightLbs(String(q.weight));

          if (wErr) newErrors.weight = wErr;
        }
      }
      if (!q.currentLocation.trim()) newErrors.currentLocation = "Location is required";
      if (!q.bloodGroup.trim()) newErrors.bloodGroup = "Blood Group is required";
      const dob = q.dateOfBirth;
      console.log(dob)
      const minDate = "1925-01-01";
      const maxDate = new Date().toISOString().split("T")[0];

      if (!dob) {
        newErrors.dateOfBirth = "Date of Birth is required";
      } else if (dob < minDate) {
        newErrors.dateOfBirth = "Date cannot be before 01-01-1925";
      } else if (dob > maxDate) {
        newErrors.dateOfBirth = "Future dates are not allowed";
      }



    } else if (step === 1) {
      if (!q.emergencyContactName.trim()) newErrors.emergencyContactName = "Emergency Contact Name is required";
      if (!q.emergencyRelationship.trim()) newErrors.emergencyRelationship = "Relationship is required";

      if (!q.emergencyPhoneNumber.trim()) {
        newErrors.emergencyPhoneNumber = "Phone Number is required";
      } else if (q.emergencyPhoneNumber.trim().length < 10) {
        newErrors.emergencyPhoneNumber = "Enter a valid phone number";
      }

      if (!q.emergencyContactConsent) newErrors.emergencyContactConsent = "Consent is required";
    } else if (step === 3) {
      if (!q.currentlyTakingMedications) {
        newErrors.currentlyTakingMedications = "Please select an option";
      }
      if (
        q.currentlyTakingMedications === "true" &&
        (!q.patientMedicationIds || q.patientMedicationIds.length === 0)
      ) {
        newErrors.patientMedicationIds = "Please list your medications";
      } else {
        delete newErrors.patientMedicationIds;
      }
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSaveQuestionnaire = async () => {
    if (validateStep(activeStep)) {
      try {
        const eff = getEffectiveUserData();
        const patientId = eff?.patientId || null;

        const payload = {
          ...questionnaireData,
          emergencyContactConsent:
            questionnaireData.emergencyContactConsent === "true",

          currentlyTakingMedications:
            questionnaireData.currentlyTakingMedications === "true",
          patientId,
          userId: eff?.userId,
        };

        const isUpdate = !!patientId;
        const response: any = await createPatient(payload).unwrap();
        const patientId1 = response?.data?.patientId;
        if (response?.data?.coinSummary?.coinsEarned) {
          triggerCoins(response?.data?.coinSummary?.coinsEarned ? response?.data?.coinSummary?.coinsEarned : 0, response?.data?.coinSummary?.totalCoins ? response?.data?.coinSummary?.totalCoins : 0)

        }

        const ap = readActiveProfile();
        if (ap.mode === "related") {
          patchActiveRelatedPatientId(patientId1);
        } else {
          let stored = readPrimaryUserData();
          if (stored) {
            stored.patientId = patientId1;
            if (localStorage.getItem("userData")) {
              localStorage.setItem("userData", JSON.stringify(stored));
            } else {
              sessionStorage.setItem("userData", JSON.stringify(stored));
            }
          }
        }
        const toastMsg = (typeof response?.data === "string" && response.data) || response?.message || (isUpdate ? "Patient updated successfully." : "Patient created successfully.");
        toast.success(toastMsg);
        setShowModal1(false);
      } catch (error: any) {
        toast.error(error?.data?.message || "Failed to save questionnaire");
      }
    }
  };

  const steps = [
    "Basic Info",
    "Emergency",
    "Health Overview",
    "Medications",
    "Family History",
    "Goals",
    "Final Input",
  ];
  const [units, setUnits] = useState({ height: 'cm', weight: 'kg' });

  useEffect(() => {
    if (showModal1) {
      setUnits({
        height: inferHeightUnit(questionnaireData.height),
        weight: inferWeightUnit(questionnaireData.weight),
      });
    }
  }, [showModal1]);



  const handleNext = () => {
    if (validateStep(activeStep)) {
      setActiveStep((prev) => Math.min(prev + 1, steps.length - 1));
    }

  };

  const handleBack = () => setActiveStep((prev) => Math.max(prev - 1, 0));

  const yesNoOptions = [
    { value: "true", label: "Yes" },
    { value: "false", label: "No" },
  ];

  const sexOptions = [
    { value: "MALE", label: "Male" },
    { value: "FEMALE", label: "Female" },
    // { value: "INTERSEX", label: "Intersex" },
    { value: "PREFER_NOT_TO_SAY", label: "Prefer not to say" },
  ];

  const genderIdentityOptions = [
    { value: "MALE", label: "Male" },
    { value: "FEMALE", label: "Female" },
    // { value: "NON_BINARY", label: "Non-binary" },
    // { value: "TRANSGENDER_MAN", label: "Transgender man" },
    // { value: "TRANSGENDER_WOMAN", label: "Transgender woman" },
    // { value: "OTHER", label: "Different identity (write in)" },
    { value: "PREFER_NOT_TO_SAY", label: "Prefer not to say" },
  ];



  const selectStyles = {
    control: (base: any) => ({
      ...base,
      minHeight: "38px",
      borderColor: "#ced4da",
      boxShadow: "none",
      "&:hover": { borderColor: "#86b7fe" },
    }),
    menuPortal: (base: any) => ({ ...base, zIndex: 9999 }),
  };

  const defaultBpData = [118, 120, 122, 119, 124, 121, 117];
  const defaultHrData = [72, 75, 78, 74, 80, 76, 73];
  const defaultGlucoseData = [102, 108, 104, 110, 105, 109, 103];
  const defaultOxygenData = [97, 98, 96, 99, 97, 98, 97];
  const defaultTimeData = ["8 AM", "10 AM", "12 PM", "2 PM", "4 PM", "6 PM", "8 PM"];

  const [bpData, setBpData] = useState<number[]>(defaultBpData);
  const [hrData, setHrData] = useState<number[]>(defaultHrData);
  const [glucoseData, setGlucoseData] = useState<number[]>(defaultGlucoseData);
  const [oxygenData, setOxygenData] = useState<number[]>(defaultOxygenData);
  const [timeData, setTimeData] = useState<string[]>(defaultTimeData);

  useEffect(() => {
    if (vitals?.length) {
      const bp = vitals.filter((v: any) => v?.vitalType === "BP");
      const hr = vitals.filter((v: any) => v?.vitalType === "HR");
      const glucose = vitals.filter((v: any) => v?.vitalType === "GLUCOSE" || v?.vitalType === "SUGAR");
      const spo2 = vitals.filter((v: any) => v?.vitalType === "SPO2");

      setBpData(
        bp.length > 1
          ? bp.map((v: any) => Number(v.systolic ?? v.valueNumeric))
          : defaultBpData
      );
      setHrData(hr.length > 1 ? hr.map((v: any) => Number(v.valueNumeric)) : defaultHrData);
      setGlucoseData(
        glucose.length > 1
          ? glucose.map((v: any) => Number(v.valueNumeric))
          : defaultGlucoseData
      );
      setOxygenData(spo2.length > 1 ? spo2.map((v: any) => Number(v.valueNumeric)) : defaultOxygenData);

      setTimeData(
        hr.length > 1
          ? hr.map((v: any) => new Date(v.measuredAt).toLocaleTimeString([], { hour: "numeric", minute: "2-digit" }))
          : defaultTimeData
      );
    } else {
      setBpData(defaultBpData);
      setHrData(defaultHrData);
      setGlucoseData(defaultGlucoseData);
      setOxygenData(defaultOxygenData);
      setTimeData(defaultTimeData);
    }
  }, [vitals]);

  const getChartOptions = (chartId: string, lineColor: string, axisColor: string): ApexOptions => ({
    chart: {
      id: chartId,
      height: undefined,
      zoom: { enabled: true },
      toolbar: { show: false },
    },
    stroke: {
      width: 3,
      curve: "smooth" as const,
      colors: [lineColor],
    },
    grid: {
      borderColor: axisColor === "#fff" ? "#6f63c6" : "#dbe3f0",
    },
    tooltip: {
      theme: axisColor === "#fff" ? "dark" : "light",
    },
    xaxis: {
      categories: timeData,
      labels: {
        style: {
          colors: Array(timeData.length).fill(axisColor),
        },
      },
    },
    yaxis: {
      show: true,
      labels: {
        style: {
          colors: [axisColor],
        },
      },
    },
    markers: {
      size: 3,
      colors: [lineColor],
      strokeColors: lineColor,
      strokeWidth: 2,
      hover: {
        size: 8,
      },
    },
  });
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedRow, setSelectedRow] = useState<any>(null);
  const [submit] = useMarkTakenMutation();

  const handleToggle = (record: any) => {

    setSelectedRow(record);
    setIsModalOpen(true);



  };



  const handleCancel = () => {

    setIsModalOpen(false);
  };
  const handleConfirm = async () => {
    try {
      const response = await submit({
        patientId: patientID,
        drugIntakeProgressId: selectedRow?.drugIntakeProgressId,
      }).unwrap();

      if (response?.data?.coinSummary?.coinsEarned) {
        triggerCoins(response?.data?.coinSummary?.coinsEarned ? response?.data?.coinSummary?.coinsEarned : 1, response?.data?.coinSummary?.totalCoins ? response?.data?.coinSummary?.totalCoins : 5)

      }
      setIsModalOpen(false);
    } catch (err) {
      console.error(err);
    }
  };
  const stepContents = [
    // Step 0 - Basic Info
    <div className="row g-3">
      <div className="col-md-6">
        <label className="form-label">First Name <span className="text-danger">*</span></label>
        <input type="text" className="form-control" placeholder="First Name" value={questionnaireData.firstName ? questionnaireData.firstName.charAt(0).toUpperCase() + questionnaireData.firstName.slice(1).toLowerCase() : ""} style={{ backgroundColor: "#e9ecef", cursor: "not-allowed" }} />
        {errors.firstName && <p className="text-danger mt-1 mb-0 fs-12">{errors.firstName}</p>}
      </div>

      <div className="col-md-6">
        <label className="form-label">Middle Name</label>
        <input type="text" className="form-control" placeholder="Middle Name" value={questionnaireData.middleName ? questionnaireData.middleName.charAt(0).toUpperCase() + questionnaireData.middleName.slice(1).toLowerCase() : ""} style={{ backgroundColor: "#e9ecef", cursor: "not-allowed" }} />
      </div>

      <div className="col-md-6">
        <label className="form-label">Last Name <span className="text-danger">*</span></label>
        <input type="text" className="form-control" placeholder="Last Name" value={questionnaireData.lastName ? questionnaireData.lastName.charAt(0).toUpperCase() + questionnaireData.lastName.slice(1).toLowerCase() : ""} style={{ backgroundColor: "#e9ecef", cursor: "not-allowed" }} />
        {errors.lastName && <p className="text-danger mt-1 mb-0 fs-12">{errors.lastName}</p>}
      </div>

      <div className="col-md-6">
        <label className="form-label">Date of Birth</label> <span className="text-danger">*</span>
        <input
          type="date"
          className="form-control"
          defaultValue={questionnaireData.dateOfBirth}
          min="1925-01-01"
          max={new Date().toISOString().split("T")[0]}

          onChange={(e) => {
            const val = e.target.value; // This will be "2027-01-01"

            // Update the state immediately so the user can see what they are typing
            handleQChange("dateOfBirth", val);

            // Then run your validation logic to show the error message
            const minDate = "1925-01-01";
            const maxDate = new Date().toISOString().split("T")[0];
            let errorMsg = "";

            if (!val) {
              errorMsg = "Date of Birth is required";
            } else if (val < minDate) {
              errorMsg = "Date cannot be before 01-01-1925";
            } else if (val > maxDate) {
              errorMsg = "Future dates are not allowed";
            }

            setErrors((prev: any) => ({ ...prev, dateOfBirth: errorMsg }));
          }}
        />
        {errors.dateOfBirth && <p className="text-danger mt-1 mb-0 fs-12">{errors.dateOfBirth}</p>}
      </div>

      <div className="col-md-6">
        <label className="form-label">Gender Identity</label> <span className="text-danger">*</span>
        <Select
          styles={{
            ...selectStyles,
            menuPortal: (base) => ({
              ...base,
              zIndex: 9999,
            }),
          }}
          classNamePrefix="react-select"
          options={genderIdentityOptions}
          value={genderIdentityOptions.find(o => o.value === questionnaireData.gender)}
          onChange={(val: any) => handleQChange('gender', val?.value || "")}
          placeholder="Select"
          menuPortalTarget={document.body}
        />
        {errors.gender && <p className="text-danger mt-1 mb-0 fs-12">{errors.gender}</p>}
      </div>

      <div className="col-md-6">
        <label className="form-label">Sex assigned at birth</label> <span className="text-danger">*</span>
        <Select
          styles={{
            ...selectStyles,
            menuPortal: (base) => ({
              ...base,
              zIndex: 9999,
            }),
          }}
          classNamePrefix="react-select"
          options={sexOptions}
          value={sexOptions.find(o => o.value === questionnaireData.sexAssignedAtBirth)}
          onChange={(val: any) => handleQChange('sexAssignedAtBirth', val?.value || "")}
          placeholder="Select"
          menuPortalTarget={document.body}
        />
        {errors.sexAssignedAtBirth && <p className="text-danger mt-1 mb-0 fs-12">{errors.sexAssignedAtBirth}</p>}
      </div>

      {/* Height Field */}
      <div className="col-md-6">
        <div className="d-flex justify-content-between align-items-end mb-2">
          <label className="form-label mb-0">Height <span className="text-danger">*</span></label>
          <div className="unit-toggle-container">
            <button
              type="button"
              className={`unit-btn ${units.height === 'cm' ? 'active' : ''}`}
              onClick={() => handleHeightUnitChange("cm")}
            >CM</button>
            <button
              type="button"
              className={`unit-btn ${units.height === 'ft/in' ? 'active' : ''}`}
              onClick={() => handleHeightUnitChange("ft/in")}
            >FT/IN</button>
          </div>
        </div>
        <div className="input-group">
          <input
            disabled={!questionnaireData.dateOfBirth}
            type="text"
            className="form-control"
            placeholder={units.height === 'cm' ? "180" : "Type e.g. 60 → 6'0\""}
            value={questionnaireData.height}
            onChange={(e) => {
              const rawValue = e.target.value;

              let value =
                units.height === "cm"
                  ? rawValue.replace(/[^0-9]/g, "")
                  : sanitizeHeightFtInTyping(rawValue);

              // 👉 RESTRICT MAX 300 (ONLY FOR CM)
              if (units.height === "cm") {
                if (value && parseInt(value) > 300) {
                  value = "300"; // clamp to max
                }
              }

              handleQChange("height", value);

              // 👉 VALIDATION START
              const ageInMonths = getAgeInMonths(questionnaireData.dateOfBirth);

              let height = null;

              if (units.height === "cm") {
                height = parseFloat(value);
              } else {
                height = convertFtInToCm(value);
              }

              let errorMsg = "";

              if (ageInMonths !== null && ageInMonths <= 1) {
                if (!value) {
                  errorMsg = "Height is required";
                } else if (!height || height < 45 || height > 60) {
                  errorMsg = "For newborn, height must be between 45–60 cm";
                }
              }

              setErrors((prev: any) => ({
                ...prev,
                height: errorMsg,
              }));
            }}
            onBlur={(e) => {
              if (units.height !== "ft/in") return;
              const v = e.target.value.trim();
              if (!v) return;
              const next = formatHeightFtInInput(v);
              if (next && next !== e.target.value) {
                handleQChange("height", next);
              }
            }}
          />
          <span className="input-group-text fs-12 text-muted" style={{ width: '52px', justifyContent: 'center', backgroundColor: '#f9fafb' }}>
            {units.height === "cm" ? "cm" : "ft/in"}
          </span>
        </div>
        {errors.height && <p className="text-danger mt-1 mb-0 fs-12">{errors.height}</p>}
      </div>

      {/* Weight Field */}
      <div className="col-md-6">
        <div className="d-flex justify-content-between align-items-end mb-2">
          <label className="form-label mb-0">Weight <span className="text-danger">*</span></label>
          <div className="unit-toggle-container">
            <button
              type="button"
              className={`unit-btn ${units.weight === 'kg' ? 'active' : ''}`}
              onClick={() => handleWeightUnitChange("kg")}
            >KG</button>
            <button
              type="button"
              className={`unit-btn ${units.weight === 'lbs' ? 'active' : ''}`}
              onClick={() => handleWeightUnitChange("lbs")}
            >LBS</button>
          </div>
        </div>
        <div className="input-group">
          <input
            disabled={!questionnaireData.dateOfBirth}
            type="text"
            className="form-control"
            placeholder={units.weight === 'kg' ? "75" : "165"}
            value={questionnaireData.weight}

            onChange={(e) => {
              let value = e.target.value
                .replace(/[^0-9.]/g, "")
                .replace(/(\..*?)\..*/g, "$1");

              // 👉 RESTRICT MAX 500 (ONLY FOR LBS)
              if (units.weight === "kg") {
                if (value && parseFloat(value) > 500) {
                  value = "500"; // clamp to max
                }
              }

              handleQChange("weight", value);

              const ageInMonths = getAgeInMonths(questionnaireData.dateOfBirth);

              let weight = parseFloat(value);

              // 👉 convert lbs → kg
              if (units.weight === "lbs") {
                weight = weight * 0.453592;
              }

              let errorMsg = "";

              if (ageInMonths !== null && ageInMonths <= 1) {
                if (!value) {
                  errorMsg = "Weight is required";
                } else if (weight < 2 || weight > 5) {
                  errorMsg = "For newborn, weight must be between 2–5 kg";
                }
              }

              setErrors((prev: any) => ({
                ...prev,
                weight: errorMsg,
              }));
            }}
          />
          <span className="input-group-text  fs-12 text-muted" style={{ width: '52px', justifyContent: 'center', backgroundColor: '#f9fafb' }}>
            {units.weight}
          </span>
        </div>
        {errors.weight && <p className="text-danger mt-1 mb-0 fs-12">{errors.weight}</p>}
      </div>

      <div className="col-md-6">
        <label className="form-label">Current Location</label> <span className="text-danger">*</span>
        <input type="text" className="form-control" placeholder="Country, State/Region" value={questionnaireData.currentLocation} onChange={(e) => handleQChange('currentLocation', e.target.value.trimStart())} />
        {errors.currentLocation && <p className="text-danger mt-1 mb-0 fs-12">{errors.currentLocation}</p>}
      </div>
      <div className="col-md-6">
        {/* <div className="form-group"> */}
        <label className="form-label">Blood Group</label> <span className="text-danger">*</span>
        <select
          name="bloodGroup"
          value={questionnaireData.bloodGroup}
          onChange={(e) => handleQChange("bloodGroup", e.target.value)}
          className={`form-select`}
        >
          <option value="" disabled hidden>Select Blood Group</option>
          <option value="A+">A+</option>
          <option value="A-">A-</option>
          <option value="B+">B+</option>
          <option value="B-">B-</option>
          <option value="O+">O+</option>
          <option value="O-">O-</option>
          <option value="AB+">AB+</option>
          <option value="AB-">AB-</option>
        </select>
        {errors.bloodGroup && <p className="text-danger mt-1 mb-0 fs-12">{errors.bloodGroup}</p>}
      </div>

      {/* </div> */}
    </div>,

    // Step 1 - Emergency
    <div className="row g-3">
      <div className="col-md-6">
        <label className="form-label">Emergency Contact Name</label> <span className="text-danger">*</span>
        <input type="text" className="form-control" placeholder="Name" value={questionnaireData.emergencyContactName} onChange={(e) => handleQChange('emergencyContactName', e.target.value.trimStart())} />
        {errors.emergencyContactName && <p className="text-danger mt-1 mb-0 fs-12">{errors.emergencyContactName}</p>}
      </div>

      <div className="col-md-6">
        <label className="form-label">Relationship</label> <span className="text-danger">*</span>

        <Select
          classNamePrefix="react-select"
          inputId="emergencyRelationship"
          options={relationshipTypeSelectOptions}
          value={selectedRelationshipOption}
          onChange={(val: any) => handleQChange("emergencyRelationship", val?.value || "")}
          placeholder="Select"
          styles={selectStyles}
          isClearable={false}
          menuPortalTarget={document.body}
        />
        {errors.emergencyRelationship && (
          <p className="text-danger mt-1 mb-0 fs-12">{errors.emergencyRelationship}</p>
        )}
      </div>

      <div className="col-md-6">
        <label className="form-label">Phone Number</label> <span className="text-danger">*</span>
        <input type="tel" name="emergencyPhoneNumber" className="form-control" placeholder="Phone Number" value={questionnaireData.emergencyPhoneNumber} maxLength={10} onChange={handleInputChange}
        />
        {errors.emergencyPhoneNumber && <p className="text-danger mt-1 mb-0 fs-12">{errors.emergencyPhoneNumber}</p>}
      </div>

      <div className="col-md-6">
        <label className="form-label">
          Can we contact this person in case of a serious health concern? <span className="text-danger">*</span>
        </label>
        <Select
          styles={{
            ...selectStyles,
            menuPortal: (base) => ({
              ...base,
              zIndex: 9999, // higher than MUI Dialog (default ~1300)
            }),
          }}
          classNamePrefix="react-select"
          options={yesNoOptions}
          value={yesNoOptions.find(o => o.value === questionnaireData.emergencyContactConsent)}
          onChange={(val: any) => handleQChange('emergencyContactConsent', val?.value)}
          placeholder="Select"
          menuPortalTarget={document.body}
        />
        {errors.emergencyContactConsent && <p className="text-danger mt-1 mb-0 fs-12">{errors.emergencyContactConsent}</p>}
      </div>
      {(questionnaireData.emergencyContactConsent === "true" || questionnaireData.emergencyContactConsent === "false") && (
        <div className="col-12 fade-in">
          <div
            className="p-3 rounded d-flex align-items-center"
            style={{
              backgroundColor:
                questionnaireData.emergencyContactConsent === "true"
                  ? "#eafaf1"
                  : "#fff3f3",
              borderLeft:
                questionnaireData.emergencyContactConsent === "true"
                  ? "4px solid #28a745"
                  : "4px solid #dc3545",
            }}
          >
            <p
              className="mb-0 small fw-medium d-flex align-items-center"
              style={{ color: "#32325d" }}
            >
              <CheckCircle
                className="me-2"
                style={{
                  fontSize: 18,
                  color:
                    questionnaireData.emergencyContactConsent === "true"
                      ? "#28a745"
                      : "#dc3545",
                }}
              />

              {questionnaireData.emergencyContactConsent === "true" &&
                "Yes, you may contact this person if there is a serious health issue."}

              {questionnaireData.emergencyContactConsent === "false" &&
                "No, please do not contact this person for any health-related emergency."}
            </p>
          </div>
        </div>
      )}
    </div>,

    // Step 2 - Health Overview
    <div className="row g-3">
      <div className="col-12">
        <label className="form-label">Diagnosed Conditions</label>
        <Select
          styles={{
            ...selectStyles,
            menuPortal: (base) => ({
              ...base,
              zIndex: 9999, // higher than MUI Dialog (default ~1300)
            }),
          }}
          classNamePrefix="react-select"
          onInputChange={(val) => setConditionSearch(val)}
          options={conditionOptions}
          getOptionValue={(option: any) => option.id}
          formatOptionLabel={(option: any) => (
            <span title={option.descriptions}>
              {option.descriptions}
            </span>
          )}
          isMulti
          getOptionLabel={(option: any) => option.name}
          value={selectedConditions}
          onChange={(val: any) => {
            setSelectedConditions(val || []);
            handleQChange(
              "diagnosedConditionIds",
              val ? val.map((o: any) => o.id) : []
            );
          }}
          placeholder="Select conditions"
          menuPortalTarget={document.body}
        />
      </div>

      <div className="col-12">
        <label className="form-label">Allergies</label>
        <Select
          styles={{
            ...selectStyles,
            menuPortal: (base) => ({
              ...base,
              zIndex: 9999, // higher than MUI Dialog (default ~1300)
            }),
          }}

          classNamePrefix="react-select"
          isMulti
          getOptionLabel={(option: any) => option.name}
          onInputChange={(val) => setAllergySearch(val)}
          options={allergyOptions}
          getOptionValue={(option: any) => option.id}
          formatOptionLabel={(option: any) => (
            <span title={option.descriptions}>
              {option.descriptions}
            </span>
          )}
          value={selectedAllergies}
          onChange={(val: any) => {
            setSelectedAllergies(val || []);
            handleQChange(
              "allergyIds",
              val ? val.map((o: any) => o.id) : []
            );
          }}
          placeholder="Select allergies"
          menuPortalTarget={document.body}
        />
      </div>
    </div>,

    // Step 3 - Medications
    <div className="row g-3">
      <div className="col-md-6">
        <label className="form-label">Currently taking medications?</label> <span className="text-danger">*</span>
        <Select
          styles={{
            ...selectStyles,
            menuPortal: (base) => ({
              ...base,
              zIndex: 9999, // higher than MUI Dialog (default ~1300)
            }),
          }}
          classNamePrefix="react-select"
          options={yesNoOptions}
          value={yesNoOptions.find(o => o.value === questionnaireData.currentlyTakingMedications)}
          onChange={(val: any) => handleQChange('currentlyTakingMedications', val?.value)}
          placeholder="Select"
          menuPortalTarget={document.body}
        />
        {errors.currentlyTakingMedications && <p className="text-danger mt-1 mb-0 fs-12">{errors.currentlyTakingMedications}</p>}
      </div>

      <div className="col-md-6">
        <label className="form-label">Medication Names <span className="text-danger">*</span></label>


        <Select
          styles={{
            ...selectStyles,
            menuPortal: (base) => ({
              ...base,
              zIndex: 9999, // higher than MUI Dialog (default ~1300)
            }),
          }}
          classNamePrefix="react-select"
          onInputChange={(val) => setMedicationSearch(val)}
          options={medicationOptions}
          isMulti
          getOptionLabel={(option: any) => option.name}
          getOptionValue={(option: any) => option.id}

          value={selectedMedications}
          onChange={(val: any) => {
            setSelectedMedications(val || []);
            handleQChange(
              "patientMedicationIds",
              val ? val.map((o: any) => o.id) : []
            );
          }}
          placeholder="Medication name(s)"
          menuPortalTarget={document.body}
          formatOptionLabel={(option: any) => (
            <span title={option.descriptions}>
              {option.descriptions}
            </span>
          )}

        />
        {errors.patientMedicationIds && <p className="text-danger mt-1 mb-0 fs-12">{errors.patientMedicationIds}</p>}
      </div>

      <div className="col-12">
        <label className="form-label">
          Supplements / Non-prescription Remedies
        </label>
        <Select
          styles={{
            ...selectStyles,
            menuPortal: (base) => ({
              ...base,
              zIndex: 9999, // higher than MUI Dialog (default ~1300)
            }),
          }}
          classNamePrefix="react-select"
          onInputChange={(val) => setSupplementSearch(val)}
          options={supplementOptions}
          isMulti
          getOptionLabel={(option: any) => option.name}
          getOptionValue={(option: any) => option.id}
          value={selectedSupplements}
          onChange={(val: any) => {
            setSelectedSupplements(val || []);
            handleQChange(
              "supplementIds",
              val ? val.map((o: any) => o.id) : []
            );
          }}
          placeholder="Select supplements"
          menuPortalTarget={document.body}
          formatOptionLabel={(option: any) => (
            <span title={option.descriptions}>
              {option.descriptions}
            </span>
          )}

        />
      </div>
    </div>,

    // Step 4 - Family History
    <div className="col-12">
      <label className="form-label">
        Family History (Close family conditions)
      </label>
      <Select
        styles={{
          ...selectStyles,
          menuPortal: (base) => ({
            ...base,
            zIndex: 9999,
          }),
        }}

        classNamePrefix="react-select"
        isMulti
        getOptionLabel={(option: any) => option.name}
        getOptionValue={(option: any) => option.id}
        value={selectedFamilyHistory}

        onChange={(val: any) => {
          setSelectedFamilyHistory(val || []);
          handleQChange(
            "familyHistoryDiseaseIds",
            val ? val.map((o: any) => o.id) : []
          );
        }}
        onInputChange={(val) => setFamilySearch(val)}
        options={familyOptions}
        placeholder="Select conditions"
        menuPortalTarget={document.body}




        formatOptionLabel={(option: any) => (
          <span title={option.descriptions}>
            {option.descriptions}
          </span>
        )}

      />
    </div>,

    // Step 5 - Goals
    <div className="col-12">
      <label className="form-label">What would you like help with most?</label>


      <textarea
        className="form-control"
        rows={4}
        placeholder="Enter Goals"
        value={questionnaireData.goals} onChange={(e) => handleQChange('goals', e.target.value.trimStart())}
      />
      {errors.goals && <p className="text-danger mt-1 mb-0 fs-12">{errors.goals}</p>}

    </div>,

    // Step 6 - Final Input
    <div className="col-12">
      <label className="form-label">
        Is there anything you'd like us to know about your health right now?
      </label>
      <textarea
        className="form-control"
        rows={4}
        placeholder="Type"
        value={questionnaireData.finalInput}
        onChange={(e) => handleQChange('finalInput', e.target.value.trimStart())}
      />
    </div>,
  ];




  return (
    <div className="content-wrapper">
      <div className="container-full">
        <section className="content1">
          <div className="mb-20 d-flex justify-content-between align-items-center">
            <div className="d-flex align-items-center justify-content-between">
              <div>
                <h1 className="h3 mb-1 fw-bold text-dark">
                  Welcome Back,{" "}
                  <span className="text-primary">
                    {userData?.firstName
                      ? [
                        formatName(userData.firstName),
                        formatName(userData.middleName || ""),
                        formatName(userData.lastName || ""),
                      ]
                        .filter(Boolean)
                        .join(" ")
                      : "John Doe"}
                  </span>
                </h1>
                <p className="text-muted mb-0 small">
                  Here’s what’s happening with your health stats today.
                </p>
              </div>
            </div>
            <div className="d-flex gap-2">
              <button className="btn-add-dashboard btn-add-dashboard-vital d-flex align-items-center gap-2">
                <PlusCircleOutlined /> <span>New Vital</span>
              </button>

              <button className="btn-add-dashboard btn-add-dashboard-report d-flex align-items-center gap-2">
                <FileTextOutlined /> <span>Reports</span>
              </button>

              <button className="btn-add-dashboard btn-add-dashboard-upload d-flex align-items-center gap-2">
                <UploadOutlined /> <span>Upload</span>
              </button>
            </div>
          </div>
          <div className="row">
            {/* BP Card */}
            <div className="col-xl-3 col-lg-6 col-12">
              <div className="box bg-primary text-white">
                <div className="box-body">
                  <div className="mb-15 d-flex justify-content-between align-items-center">
                    <h4 className="my-0">BP</h4>
                    <i className="fs-18 mdi mdi-heart-outline"></i>
                  </div>
                  <h5 className="fw-400 my-0">120/80</h5>
                </div>
                <div className="box-body pt-0 " style={{ padding: '5%' }}>
                  <div id="heartrate" style={{ height: '100%' }}>
                    {bpData.length > 0 ? (<ReactApexChart
                      type="line"
                      height={200}  // Set height
                      width="100%"  // Set width
                      options={getChartOptions("bp-chart", "#ffffff", "#fff")}

                      series={[
                        {
                          name: "BP",
                          data: bpData
                        }
                      ]}
                    />) : (<p>No data available </p>)}
                  </div>
                </div>
              </div>
            </div>
            {/* Heart Rate Card */}
            <div className="col-xl-3 col-lg-6 col-12">
              <div className="box text-white box-typography">
                <div className="box-body">
                  <div className="mb-15 d-flex justify-content-between align-items-center">
                    <h4 className="my-0">Heart Rate</h4>
                    <i className="fs-18 mdi mdi-heart-outline"></i>
                  </div>
                  <h5 className="fw-400 my-0">75 bpm</h5>
                </div>
                <div className="box-body pt-0 " style={{ padding: '5%' }}>
                  <div id="heartrate" style={{ height: '100%' }}>
                    {hrData.length > 0 ? (<ReactApexChart
                      type="line"
                      height={200}
                      width="100%"
                      options={getChartOptions("heart-rate-chart", "#5156be", "#64748b")}
                      series={[
                        {
                          name: "Heart Rate",
                          data: hrData
                        }
                      ]}
                    />) : (<p style={{ color: "black" }}>No data available </p>)}
                  </div>
                </div>
              </div>
            </div>

            {/* Glucose Level Card */}
            <div className="col-xl-3 col-lg-6 col-12">
              <div className="box bg-primary text-white">
                <div className="box-body">
                  <div className="mb-15 d-flex justify-content-between align-items-center">
                    <h4 className="my-0">Glucose Level(Sugar)</h4>
                    <i className="fs-18 mdi mdi-heart-outline"></i>
                  </div>
                  <h5 className="fw-400 my-0">110 mg/dL</h5>
                </div>
                <div className="box-body pt-0" style={{ padding: '5%' }}>
                  <div id="heartrate" style={{ height: '100%' }}>
                    {glucoseData.length > 0 ? (<ReactApexChart
                      type="line"
                      height={200}
                      width="100%"
                      options={getChartOptions("glucose-chart", "#ffffff", "#fff")}
                      series={[
                        {
                          name: "Glucose",
                          data: glucoseData
                        }
                      ]}
                    />) : (<p>No data available </p>)}
                  </div>
                </div>
              </div>
            </div>

            {/* Oxygen Card */}
            <div className="col-xl-3 col-lg-6 col-12">
              <div className="box text-white box-typography">
                <div className="box-body">
                  <div className="mb-15 d-flex justify-content-between align-items-center">
                    <h4 className="my-0">Oxygen</h4>
                    <i className="fs-18 mdi mdi-heart-outline"></i>
                  </div>
                  <h5 className="fw-400 my-0">97%</h5>
                </div>
                <div className="box-body pt-0 " style={{ padding: '5%' }}>
                  <div id="heartrate" style={{ height: '100%' }}>
                    {oxygenData.length > 0 ? (<ReactApexChart
                      type="line"
                      height={200}
                      width="100%"
                      options={getChartOptions("oxygen-chart", "#5156be", "#64748b")}
                      series={[
                        {
                          name: "Oxygen",
                          data: oxygenData
                        }
                      ]}
                    />) : (<p style={{ color: "black" }}>No data available </p>)}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className='row'>
            <div className="col-xxxl-8 col-xl-7 col-12">
              <div className="box notification-box">
                <div className="box-header">
                  <h4 className="box-title">Medicine Schedule</h4>
                </div>
                <div className="box-body notification-list">
                  {drugIntake?.length > 0 ? (
                    drugIntake.map((drug: any) => (
                      <div key={drug?.medicationId} className="med-row-container rounded-3">
                        <div className="med-info-section">
                          <div className="med-icon-box">
                            <i className="fa fa-medkit" aria-hidden="true"></i>
                          </div>

                          <div className="med-text">
                            <div className="med-title">{drug?.medicationName}</div>

                            <div className="med-meta">
                              <span><i className="fa fa-calendar"></i> {drug.intakeDate}</span>
                              <span className="text-muted">|</span>
                              <span><i className="fa fa-clock-o"></i> {drug.scheduledTime}</span>
                              <span className="text-muted">|</span>
                              <span className="dose-highlight">
                                <i className="fa fa-flask"></i> {drug.dosage}
                              </span>
                            </div>
                          </div>
                        </div>

                        <div className="med-action-section">
                          <div className="button-group">
                            <button
                              className="btn btn-primary btn-sm"
                              onClick={() =>
                                navigate("/medication", {
                                  state: {
                                    medicationDetail: {
                                      medicationId: drug?.medicationId,
                                      medicationName: drug?.medicationName,
                                      intakeDate: drug?.intakeDate,
                                      scheduledTime: drug?.scheduledTime,
                                      dosage: drug?.dosage,
                                    },
                                  },
                                })
                              }
                            >
                              <i className="fa fa-info-circle"></i> Details
                            </button>
                            <button
                              className="btn btn-success btn-sm"
                              style={{ marginLeft: "8px" }}

                              onClick={(value: any) => handleToggle(drug)}
                              disabled={drug?.taken}
                            >
                              <i className="fa fa-check"></i>{" "}
                              {drug?.taken ? "Taken" : "Mark as Taken"}
                            </button>
                          </div>
                        </div>
                      </div>
                    ))
                  ) : (
                    <p className="text-muted text-center p-3 mb-3" >No medicines scheduled</p>
                  )}
                </div>
              </div>
            </div>

            <div className="col-xxxl-4 col-xl-5 col-12">
              <div className="box">
                <div className="box-header d-flex align-items-center justify-content-between">
                  <h4 className="box-title">Notifications</h4>

                  <div style={{ position: "relative", display: "inline-block" }}>
                    <i className="fa fa-bell" style={{ fontSize: "20px" }}></i>

                    {dashboardData?.notifications?.unreadCount > 0 && (
                      <span
                        className="badge bg-danger"
                        style={{
                          position: "absolute",
                          top: "-15px",
                          right: "-10px",
                          fontSize: "11px",
                          padding: "6px 6px",
                          borderRadius: "50%"
                        }}
                      >
                        {dashboardData.notifications.unreadCount}
                      </span>
                    )}
                  </div>
                </div>
                <div className="box-body notification-box">
                  <ul className="notification-list">

                    {notifications?.length > 0 ? (
                      notifications?.map((n: any) => (
                        <li key={n?.id} className="notification-item">
                          <span className="notify-icon info">
                            <i className="fa fa-users text-info"></i>
                          </span>

                          <div>
                            <h5>{n?.title}</h5>
                            <p className="notify-text">{n?.message}</p>
                          </div>
                        </li>
                      ))
                    ) : (
                      <p className="text-muted text-center p-3" >No notifications</p>
                    )}


                  </ul>
                </div>
              </div>
            </div>

          </div>
        </section>
      </div>
      <Dialog
        open={showModal1}
        maxWidth="md"
        fullWidth
        className="auth-modal glass-modal"
        onClose={(event, reason) => {
          // Prevent closing on backdrop click & ESC
          if (reason === "backdropClick" || reason === "escapeKeyDown") {
            return;
          }
          setShowModal1(false);
        }}
        BackdropProps={{
          style: { backgroundColor: "rgba(0,0,0,0.2)", backdropFilter: "blur(5px)" },
        }}
      >
        <DialogTitle
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            pt: 3,
            pb: 5,
          }}
        >
          <h3 style={{ margin: 0 }}>Initial Health Questionnaire</h3>
          <IconButton
            onClick={() => setShowModal1(false)}
            sx={{ color: "red" }} // red color
          >
            <CloseIcon sx={{ color: "gray", "&:hover": { color: "darkred" } }} />
          </IconButton>
        </DialogTitle>

        <DialogContent className="px-4 pb-3">
          <Stepper
            activeStep={activeStep}
            alternativeLabel
            sx={{
              "& .MuiStepConnector-root.Mui-active .MuiStepConnector-line": {
                borderColor: "#1976d2",
              },
              "& .MuiStepConnector-root.Mui-completed .MuiStepConnector-line": {
                borderColor: "#1976d2",
              },
            }}
          >
            {steps.map((label) => (
              <Step key={label}>
                <StepLabel>{label}</StepLabel>
              </Step>
            ))}
          </Stepper>

          <form className="mt-3">{stepContents[activeStep]}</form>
        </DialogContent>

        <DialogActions className="pb-3 px-4 d-flex justify-content-end">

          <button
            className="btn btn-warning"
            disabled={activeStep === 0} onClick={handleBack}
          >
            Back
          </button>

          {activeStep === steps.length - 1 ? (

            <button className="btn btn-primary" onClick={handleSaveQuestionnaire} disabled={isPostLoading}>
              {isPostLoading ? "Saving..." : "Save"}
            </button>

          ) : (

            <button className="btn btn-primary" onClick={handleNext}>
              Next
            </button>
          )}



        </DialogActions>
      </Dialog>

      <Dialog
        open={showConfirm}
        maxWidth="sm"
        fullWidth
        className="auth-modal glass-modal"
        onClose={() => setShowConfirm(false)}
        BackdropProps={{
          style: {
            backgroundColor: "rgba(0,0,0,0.2)",
            backdropFilter: "blur(5px)",
          },
        }}
      >
        {/* HEADER */}
        <DialogTitle className="pt-30 pb-10 text-center">
          <div className="h3 mb-1">Whom do you want to book an appointment </div>
          <p className="text-muted fs-14 mb-0">
            Please select a family member
          </p>
        </DialogTitle>

        {/* CONTENT */}
        <DialogContent className="px-40 pb-20 d-flex justify-content-center">
          <RadioGroup
            row
            value={selectedPerson}
            onChange={(e) => setSelectedPerson(e.target.value)}
            className="justify-content-center mt-3"
          >
            <FormControlLabel value="self" control={<Radio />} label="Self" />
            <FormControlLabel value="father" control={<Radio />} label="Father" />
            <FormControlLabel value="mother" control={<Radio />} label="Mother" />
            <FormControlLabel value="sister" control={<Radio />} label="Sister" />
            <FormControlLabel value="spouse" control={<Radio />} label="Spouse" />
          </RadioGroup>
        </DialogContent>

        {/* FOOTER */}

        <DialogActions className="pb-3 px-4 d-flex justify-content-end gap-2">
          <button className="btn btn-warning"
            onClick={() => {
              // handle booking here
              setShowConfirm(false);
            }}>Cancel</button>
          <button className="btn btn-primary" onClick={() => { setShowConfirm(false); navigate("/appointment") }} disabled={!selectedPerson}>Schedule Appointment</button>
        </DialogActions>

      </Dialog>
      <Modal1
        title={
          <div className="modal-header-wrapper">
            <div className="modal-icon-circle"><img src={medicine} alt="medicine-icon" /></div>
            <div className="modal-header-text">Mark Medication as Taken?</div>
          </div>
        }
        open={isModalOpen}
        onOk={handleConfirm}
        onCancel={handleCancel}
        okText="Yes, Mark as Taken"
        cancelText="Cancel"
        okButtonProps={{ className: "btn-confirm" }}
        cancelButtonProps={{ className: "btn-cancel" }}
      // closeIcon={
      //   <IconButton className="auth-modal-round-close" aria-label="close">
      //     <CloseIcon />
      //   </IconButton>
      // }
      >
        <div className="medication-card">
          <div className="card-content">
            <div className="card-title"><span className="check-icon"><img src={check} alt="check-icon" className="check-icon"/></span> Confirm Medication Intake</div>

            {/* Medication Name */}
            <div className="info-row">
              <span className="info-label">Medication</span>
              <span className="info-value-name">
                {selectedRow?.medicationName || "N/A"}
              </span>
            </div>

            {/* Time */}
            <div className="info-row">
              <span className="info-label">Time</span>
              <span className="info-value-time">
                {selectedRow?.scheduledTime || "12:00 AM"}
              </span>
            </div>

            <div className="helper-text">
              Are you sure you want to mark this medication as taken?
              This will update your health record.
            </div>
          </div>
        </div>
      </Modal1>
    </div>
  );
};

export default Dashboard;